import styled from "styled-components";

const Input = styled.input`
  margin: ${(p) => p.margin};
  width: ${(p) => p.width};
`;

const TextInput = ({
  value,
  onChange,
  margin = "0",
  placeholder,
  width = "100%",
}) => {
  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      margin={margin}
      placeholder={placeholder}
      width={width}
    />
  );
};

export default TextInput;
